import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import './styles.scss'

const AsideLink = ({ href, children, _blank, variant }) => (
  <a
    className={cx({
      'aside-link': true,
      [`aside-link--${variant}`]: variant
    })}
    href={href}
    target={_blank ? '_blank' : '_self'}
    rel="noreferrer"
  >
    {children}
  </a>
)

AsideLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  _blank: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary'])
}

AsideLink.defaultProps = {
  _blank: false,
  variant: 'primary'
}

export default AsideLink
